import { render, staticRenderFns } from "./StepHardware.vue?vue&type=template&id=8521295c&"
import script from "./StepHardware.vue?vue&type=script&lang=ts&"
export * from "./StepHardware.vue?vue&type=script&lang=ts&"
import style0 from "./StepHardware.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VForm})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8521295c')) {
      api.createRecord('8521295c', component.options)
    } else {
      api.reload('8521295c', component.options)
    }
    module.hot.accept("./StepHardware.vue?vue&type=template&id=8521295c&", function () {
      api.rerender('8521295c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/access/StepHardware.vue"
export default component.exports